import { render, staticRenderFns } from "./FormB2BLocal.vue?vue&type=template&id=e3c41782&scoped=true"
import script from "./FormB2BLocal.vue?vue&type=script&lang=js"
export * from "./FormB2BLocal.vue?vue&type=script&lang=js"
import style0 from "./FormB2BLocal.vue?vue&type=style&index=0&id=e3c41782&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3c41782",
  null
  
)

export default component.exports